import each from 'lodash/each'

export function calculateDistance(
    origin = { lat: 41.902782, lng: 12.496366 }, // Rome as Center Default
    store = { entry: entry, lat: null, lng: null }
) {
    if (store.lat == null || store.lng == null) {
        console.error("Store missing coordinates ({lat: null, lng: null})", store.entry)
        return
    } else {
        let km = 3959 * Math.acos(Math.cos(radians(origin.lat)) * Math.cos(radians(store.lat)) * Math.cos(radians(store.lng) - radians(origin.lng)) + Math.sin(radians(origin.lat)) * Math.sin(radians(store.lat))) / 0.62137
        return Math.ceil(km)

        function radians(degrees) { return degrees * (Math.PI / 180) }
    }
}

export async function resultRendering(origin = { lat: 41.902782, lng: 12.496366 }, distance = 50, { querySelector = null, counterLabel = null, results = null }) {
    if (querySelector == null || counterLabel == null || results == null) {
        console.error(
            "Store missing `querySelector` or `results`",
            `querySelector:${querySelector}`,
            `counterLabel:${counterLabel}`,
            `results:${results}`
        )
        return
    } else {
        let teases = querySelector
        let map_kms = new Array()
        let counter = 0
        let km = 0
        let stores = new Array()

        each(teases, (tease) => {
            tease.slug = tease.id.replace('tease-', '')

            let location = JSON.parse(tease.dataset.location)

            km = calculateDistance(
                { lat: origin.lat, lng: origin.lng },
                { lat: tease.getAttribute('lat'), lng: tease.getAttribute('lng'), entry: tease })

            map_kms.push((km))

            if (tease) {
                tease.setAttribute('data-km', km)
                if (location.spaces) {
                    tease.style.setProperty('order', `-${1000000 - km}`)
                } else {
                    tease.style.setProperty('order', `${km}`)
                }

                if (tease.querySelector('.distance')) {
                    tease.querySelector('.distance').innerHTML = `${km}km`
                }

                if ((km) > distance) {
                    tease.style.setProperty('display', 'none')
                } else {
                    tease.classList.add('available')
                    counter++
                }
            }
        })

        map_kms = map_kms.sort(function (a, b) { return a - b })

        if ((counter == 0)) {
            let item = document.querySelector('[data-km="' + map_kms[0] + '"]')

            if (item) {
                item.style.setProperty('display', 'block')

                if (item.querySelector('.distance')) {
                    item.querySelector('.distance').innerHTML = `${km}km`
                }

                counter++
            }
        }

        if (counter == 0 && counterLabel) {
            counterLabel.style.setProperty('display', 'none')
        }

        each(teases, (tease) => {
            let item = document.getElementById(`tease-${tease.slug}`)
            if (item) {
                if (tease.style.getPropertyValue('display') != "none") {
                    stores.push(item)
                }
            }
        })

        counterLabel.children[0].innerHTML = counter
        results.style.setProperty('visibility', 'visible')

        return {
            teases: teases,
            stores: stores,
            counter: counter
        }
    }
}